// /**
//  * Orders - list
//  */

// React
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
// Context
import AuthContext from '../../../authContext';

// UI
import theme from '../../../theme';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,

} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {

  mdiChevronLeft,
} from '@mdi/js';

// Components
import Can from '../../../components/Can';

// Rules


// Helper
import {
  checkMatchMedia,
  translate,
} from '../../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Parcel } from '../interfaces';
import { Typography } from '@material-ui/core';

type Data = Parcel;
type Props = {
  data: any;
  changeStatusOrderWhitId: any;
  handleOpenConfirmUpdateState: any;
};
type Ord = 'asc' | 'desc';

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '4px',

      width: '100%',
      '& .MuiTableRow-root': {

      },
    },
    paper: {
      width: '100%',
    },
    table: {
      // maxWidth: 350,
      // minWidth: 300,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: '0 10px',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 500,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string }
  ) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}



export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');



  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <TableBody>
              {props.data[0].warehouseType == 'MULTI' && props.data.length == 1
                ? stableSort(props.data[0].childOrders, getComparator(order, orderBy))
                  .slice()
                  .map((row: any, index: number) => {
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow key={index} hover role="checkbox" tabIndex={-1}>
                        {
                          row.status === 'ASSIGNED' && (<StyledTableCell id={labelId} scope="row" align="center">
                            <p>{row.id}</p>
                            <p><Can
                              role={authContext.user.role}
                              perform="orders:tracking-code"
                              yes={() => (
                                <React.Fragment>


                                  {translate(row.deliveryType)}

                                </React.Fragment>
                              )}
                            /></p>
                            <p><span>
                              {jMoment(row.deliveryDate, 'YYYY/M/D')
                                .locale('fa')
                                .format('jYY/jMM/jDD')}
                            </span>
                              &nbsp; &nbsp;- &nbsp; &nbsp;
                              <span>
                                {`${jMoment(row.deliveryStartTime, 'HH:mm:ss')
                                  .locale('fa')
                                  .format('HH')}
                        `}
                                {`تا ${jMoment(row.deliveryEndTime, 'HH:mm:ss')
                                  .locale('fa')
                                  .format('HH')}`}
                              </span></p>
                          </StyledTableCell>)
                        }



                      </TableRow>
                    );
                  }) : stableSort(props.data, getComparator(order, orderBy))
                    .slice()
                    .map((row: any, index: number) => {
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow key={index} hover role="checkbox" tabIndex={-1}>


                          <>
                            <StyledTableCell id={labelId} scope="row" align="left">
                              <Link to={`/parcels-mob/details/${row.id}`} style={{ textDecoration: 'none' }} >
                                <p style={{ fontWeight: 600 }}>{row.id}</p>
                                <p style={{ fontWeight: 600 }}>{row.name}</p>
                                <p><Can
                                  role={authContext.user.role}
                                  perform="orders:tracking-code"
                                  yes={() => (
                                    <React.Fragment>


                                      {translate(row.deliveryType)}

                                    </React.Fragment>
                                  )}
                                /></p>
                                <p style={{ color: 'lightgray' }}>


                                  <span>
                                    {`${jMoment(row.deliveryStartTime, 'HH:mm:ss')
                                      .locale('fa')
                                      .format('HH')}
                        `}
                                    {`تا ${jMoment(row.deliveryEndTime, 'HH:mm:ss')
                                      .locale('fa')
                                      .format('HH')}`}
                                  </span>
                                  &nbsp; &nbsp;- &nbsp; &nbsp;
                                  <span>
                                    {jMoment(row.deliveryDate, 'YYYY/M/D')
                                      .locale('fa')
                                      .format('jYY/jMM/jDD')}
                                  </span>
                                </p>
                              </Link>

                            </StyledTableCell>
                            <StyledTableCell align="right">
                              <Link to={`/parcels-mob/details/${row.id}`} style={{ textDecoration: 'none' }} >

                                {row.status === 'ASSIGNED' ? (

                                  <Typography style={{ color: theme.palette.orange.main }}>{translate(row.status, 'parcel')}</Typography>



                                ) : null}
                                {row.status === 'REGISTERED' ? (


                                  <Typography style={{ color: '#7b0072' }}>{translate(row.status, 'parcel')}</Typography>


                                ) : null}

                                <p>
                                  <IconButton
                                    aria-label="details"
                                    size="small"
                                    title="جزئیات سفارش"
                                    data-cy="details"
                                  >
                                    <Icon
                                      path={mdiChevronLeft}
                                      size={1.3}
                                    />
                                  </IconButton>
                                </p>
                              </Link>
                            </StyledTableCell>
                          </>



                        </TableRow>
                      );
                    })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

    </div >
  );
}
